<div class="record-status-compact">
  <div class="record-status-compact__content">
    <div class="record-status-compact__status">
      <div class="record-status-compact__dot" [ngClass]="dotColor"></div>
      <span class="record-status-compact__label">{{ statusLabel }}</span>
    </div>

    <div class="record-status-compact__actions">
      @for (action of displayActions; track action.status) {
        <lwty-button
          [text]="action.label"
          [size]="buttonSize"
          (click)="emitStatus(action.status)"
          (keydown.enter)="emitStatus(action.status)" />
      }

      @for (payment of paymentActions; track payment.id ?? $index) {
        <lwty-button
          [size]="buttonSize"
          [text]="getPaymentButtonText(payment?.amount?.amount ?? 0)"
          (click)="emitPayment(payment)"
          (keydown.enter)="emitPayment(payment)" />
      }

      @if (showCustomActions()) {
        <lwty-button
          data-testid="btn-custom-action"
          [size]="buttonSize"
          [text]="getCustomActionButtonText()"
          (click)="emitCustomAction()"
          (keydown.enter)="emitCustomAction()" />
      }
    </div>
  </div>
</div>
